
import { Mixins, Component, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import SecondaryEmail from '@/views/User/views/Settings/component/SecondaryEmail/SecondaryEmail.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'

import User from '@/views/User/models/user'

@Component({
    components: { PhoneInput, SecondaryEmail },
})
export default class ContactSettings extends Mixins<MixinInterface>() {
    loading = true
    loadingUpdate: string | false = false

    // STATES
    async created() {
        await this.getUserData()
    }

    async getUserData() {
        this.loading = true
        await User.getCurrentUser(['employer', 'secondaryEmails'])
        this.initializeUser()
        this.loading = false
    }

    initializeUser() {
        this.mobileNumber = this.currentUser.attributes.mobileNumber
        this.phoneNumber = this.currentUser.attributes.phoneNumber
    }

    // Mobile number
    mobileNumber = ''
    mobileNumberValid = false
    get mobileChanged() {
        return this.currentUser.attributes.mobileNumber != this.mobileNumber
    }

    // Phone number
    phoneNumber = ''
    phoneNumberValid = false
    get phoneChanged() {
        return this.currentUser.attributes.phoneNumber != this.phoneNumber
    }

    // Errors
    mobileExistsOnOtherUser = false

    async updateAttribute(
        event,
        attr: 'mobileNumberIsVerified' | 'primaryEmailIsVerified' | 'mobileNumber' | 'phoneNumber',
        val: string | boolean | null
    ) {
        event.preventDefault()
        this.loadingUpdate = attr
        let data = {
            type: 'user',
            id: this.currentUser.id,
            attributes: {
                [attr]: val,
            },
        }

        let res = await User.patchCurrentUser(data, this.currentUser.attributes.updatedAt, [
            'employer',
            'secondaryEmails',
        ])

        if (res && res.code) {
            if (res.code == 'mobileExistsOnOtherUser') {
                this.mobileExistsOnOtherUser = true
            }
            this.$store.commit('closeSnackbar')
        }

        if (res && res.data) {
            this.initializeUser()
        }

        this.loadingUpdate = false
    }

    // EMAIL
    @Ref('emailForm') readonly emailForm!: HTMLFormElement
    validEmail = false
    secondaryEmail = ''
    loadingNewEmail = false
    startSecondaryEmail = false
    emailExistsOnOtherUser = false
    emailAlreadyInAccount = false

    async initiateSEmailForm() {
        this.secondaryEmail = ''
        this.startSecondaryEmail = true
        await this.$nextTick()
        this.emailForm?.$children[0]?.focus()
    }
    async createSecondaryEmail(event: any) {
        event.preventDefault()
        this.loadingNewEmail = true
        if (this.secondaryEmail && this.validEmail) {
            let res = await User.postSecondaryEmail(this.currentUser.id, this.secondaryEmail)
            if (typeof res == 'string') {
                this[res] = true
            } else {
                this.resetEmailForm()
                await this.getUserData()
            }
        }

        this.loadingNewEmail = false
    }

    resetValidationEmailForm() {
        this.emailExistsOnOtherUser = false
        this.emailAlreadyInAccount = false
    }
    resetEmailForm() {
        this.startSecondaryEmail = false
        this.resetValidationEmailForm()
        this.emailForm.reset()
        this.secondaryEmail = ''
    }
}
